import i18n from '@/lang';

export const hubList = [
  // 大区
  { prop: 'regionName', label: i18n.t('collectionCenter.region'), width: 120 },
  // 州
  { prop: 'stateName', label: i18n.t('collectionCenter.state'), width: 120 },
  // 转运中心名称
  { prop: 'hubName', label: i18n.t('collectionCenter.hubName'), width: 120 },
  // 类型
  { prop: 'hubLevel', label: i18n.t('collectionCenter.levelType'), width: 120 },
  // 今日入库票数
  { prop: 'inboundTicketCount', label: i18n.t('collectionCenter.todayInboundTickets'), width: 120 },
  // 今日出库票数
  { prop: 'outboundTicketCount', label: i18n.t('collectionCenter.todayOutboundTickets'), width: 120 },
  // 当前库存票数
  { prop: 'currentTicketCount', label: i18n.t('collectionCenter.currentInventoryTickets'), width: 120 },
  // 库存周转天数
  { prop: 'stockTurnoverDays', label: i18n.t('collectionCenter.inventoryTurnoverDays'), width: 120 },
  // 近7天平均在库时长
  { prop: 'avgInventoryHours', label: i18n.t('collectionCenter.avgStorageTimeLast7Days'), width: 120 },
  // 库存老化率
  { prop: 'inventoryAgingRate', label: i18n.t('collectionCenter.inventoryAgingRate'), width: 120 },
  // 净增库存
  { prop: 'netIncreaseTicketCount', label: i18n.t('collectionCenter.netInventoryIncrease'), width: 120 },
  // ≤24h库存
  { prop: 'inventoryLe24hCount', label: i18n.t('collectionCenter.inventoryLe24h'), width: 120 },
  // 24~48h库存
  { prop: 'inventory24To48hCount', label: i18n.t('collectionCenter.inventory24_48h'), width: 120 },
  // 48~72h库存
  { prop: 'inventory48To72hCount', label: i18n.t('collectionCenter.inventory48_72h'), width: 120 },
  // 3~7天库存
  { prop: 'inventory3To7dCount', label: i18n.t('collectionCenter.inventory3_7days'), width: 120 },
  // ＞7天库存
  { prop: 'inventoryGt7dCount', label: i18n.t('collectionCenter.inventoryOver7Days'), width: 120 }
];
